import { Link } from "react-router-dom";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";

const Pagination = () => {
  return (
    <section className="pagination">
      <div className="pagination-items text-[15px] leading-4 text-black flex justify-center">
        <Link
          to={""}
          className={`prev-page shrink-0 rounded-full bg-[#eaeaea] p-2 w-9 h-9 flex items-center justify-center mx-3 transition-all duration-200 hover:bg-[#bbb]`}
        >
          <span>
            <FiArrowLeft />
          </span>
        </Link>
        {Array(4)
          .fill(true)
          .map((item, index) => (
            <Link
              key={index}
              to={""}
              className={`pager shrink-0 rounded-full bg-[#eaeaea] p-2 w-9 h-9 flex items-center justify-center mx-1 transition-all duration-200 hover:bg-[#bbb] focus:bg-[#bbb]`}
            >
              <span>{index === 2 ? "..." : index}</span>
            </Link>
          ))}
        <Link
          to={""}
          className={`next-page shrink-0 rounded-full bg-[#eaeaea] p-2 w-9 h-9 flex items-center justify-center mx-3 transition-all duration-200 hover:bg-[#bbb]`}
        >
          <span>
            <FiArrowRight />
          </span>
        </Link>
      </div>
    </section>
  );
};

export default Pagination;
